import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import { isValidElement } from "react";
import HtmlFromLangFile from "../../01-atoms/HtmlFromLangFile/HtmlFromLangFile";
import NWONBackgroundLetter from "../../01-atoms/NWONBackgroundLetter/NWONBackgroundLetter";
import {
  LetterName,
  LetterPosition,
} from "../../01-atoms/NWONBackgroundLetter/NWONBackgroundLetterInterfaces";
import NWONHashtagWrapper from "../../01-atoms/NWONHashtagWrapper/NWONHashtagWrapper";
import NWONSection from "../NWONSection/NWONSection";
import { NWONProjectIntroductionSectionProps } from "./NWONProjectIntroductionSectionInterfaces";
import { useNWONProjectIntroductionSectionStyles } from "./NWONProjectIntroductionSectionStyles";

const NWONProjectIntroductionSection = (
  props: NWONProjectIntroductionSectionProps
): JSX.Element => {
  const { project } = props;
  const { classes } = useNWONProjectIntroductionSectionStyles();

  const projectLogo = isValidElement(project.logo)
    ? project.logo
    : project.logo && (
        <Image
          placeholder="blur"
          alt="project logo"
          layout="intrinsic"
          src={project.logo}
        />
      );

  return (
    <NWONSection>
      <NWONBackgroundLetter
        letter={LetterName.N}
        position={LetterPosition.Right}
      />

      <Card>
        <CardContent>
          <Grid container={true} spacing={2} className={classes.wrapper}>
            {projectLogo && (
              <Grid
                item={true}
                xs={12}
                md={4}
                container={true}
                className={classes.logoContainer}
              >
                <Box className={classes.logoWrapper}>
                  <Link href={project.website} target="_blank">
                    {projectLogo}
                  </Link>
                </Box>
              </Grid>
            )}

            <Grid
              item={true}
              xs={12}
              md={projectLogo ? 8 : 12}
              container={true}
              className={classes.info}
            >
              <Typography variant="h5" component="h2">
                {project.title}
              </Typography>

              <Typography variant="body1" className={classes.description}>
                {typeof project.description === "string" ? (
                  <HtmlFromLangFile
                    contentContainingHtml={project.description}
                  />
                ) : (
                  project.description
                )}
              </Typography>

              <Typography
                variant="body1"
                component="a"
                href={project.website}
                target="_blank"
                className={classes.website}
              >
                {new URL(project.website).hostname}
              </Typography>

              {project.hashtags && (
                <Grid container={true} spacing={1}>
                  {project.hashtags.map((hashtag, index) => {
                    return (
                      // Disable ESLint for the next line to define the index as the key of the Grid
                      // eslint-disable-next-line react/no-array-index-key
                      <Grid item={true} key={index}>
                        <NWONHashtagWrapper hashtag={hashtag} />
                      </Grid>
                    );
                  })}
                </Grid>
              )}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </NWONSection>
  );
};

export default NWONProjectIntroductionSection;
